// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3R4ST","modal":"Modal_modal__2n0zs","slide-down":"Modal_slide-down__2oXOa"};